/** Working-harbor scenery. Boats and equipment are static art, not transport,
 * water surfaces, collision, shops or usable machinery. Map geometry owns support. */
export const HARBOR_PROP_TEMPLATES = {
  moored_fishing_skiff: { kind: 'dock', name: 'Moored fishing skiff', frame: { w: 184, h: 84 }, band: 'architecture' },
  furled_coastal_sloop: { kind: 'dock', name: 'Furled coastal sloop', frame: { w: 208, h: 188 }, band: 'architecture' },
  harbor_cargo_hoist: { kind: 'dock', name: 'Braced quay cargo hoist', frame: { w: 160, h: 188 }, band: 'architecture' },
  sail_repair_rack: { kind: 'dock', name: 'Sail and net repair rack', frame: { w: 144, h: 152 }, band: 'architecture' },
  crab_pot_stack: { kind: 'dock', name: 'Stacked mesh crab pots', frame: { w: 100, h: 84 }, band: 'vegetation' },
  fish_market_counter: { kind: 'dock', name: 'Fresh-catch market counter', frame: { w: 144, h: 96 }, band: 'vegetation' },
  life_ring_post: { kind: 'dock', name: 'Quayside life-ring post', frame: { w: 52, h: 112 }, band: 'vegetation' },
  coiled_rope_basket: { kind: 'dock', name: 'Basket of wound mooring rope', frame: { w: 84, h: 64 }, band: 'vegetation' },
} as const;

export type HarborPropTemplate = keyof typeof HARBOR_PROP_TEMPLATES;
